import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { changePassword } from '../api/auth';
import useAuthStore from '../store/authStore';
import { apiErrorMessage } from '../utils/apiError';

const { Title } = Typography;

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { updateUser, user } = useAuthStore();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await changePassword(
        values.current_password,
        values.password,
        values.password_confirmation
      );

      updateUser({ ...user, first_login: false });
      message.success('Şifreniz başarıyla güncellendi.');
      navigate('/dashboard');
    } catch (error) {
      message.error(apiErrorMessage(error, 'Şifre güncellenemedi.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <Card className="w-full max-w-md shadow-lg">
        <div className="text-center mb-8">
          <Title level={3}>Şifre Değiştir</Title>
          <p className="text-gray-500">İlk girişinizde şifrenizi değiştirmeniz gerekmektedir.</p>
        </div>

        <Form
          name="changePassword"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="current_password"
            label="Mevcut Şifre"
            rules={[{ required: true, message: 'Mevcut şifrenizi giriniz.' }]}
          >
            <Input.Password placeholder="Mevcut şifre" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Yeni Şifre"
            rules={[
              { required: true, message: 'Yeni şifrenizi giriniz.' },
              { min: 8, message: 'Şifre en az 8 karakter olmalıdır.' },
            ]}
          >
            <Input.Password placeholder="Yeni şifre" />
          </Form.Item>

          <Form.Item
            name="password_confirmation"
            label="Yeni Şifre Tekrar"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Şifrenizi tekrar giriniz.' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Şifreler eşleşmiyor.'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Yeni şifre tekrar" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="w-full"
            >
              Şifreyi Güncelle
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePassword;